<template>
  <div data-testid="client-switcher" class="client-selector-wrapper" v-if="(clients || []).length">
    <!-- Single client => simple chip -->
    <div
      data-testid="client-switcher__single-chip"
      v-if="clients.length === 1"
      label
      class="client-selector-activator d-flex align-center justify-start radius-small cursor-pointer gap-1"
    >
      <img data-testid="client-switcher__icon" class="nav-img-icon" src="/img/navicon/InvestIcon.svg" alt="">
      <span class="text-truncate flex-grow-1 side-nav-text-color">{{ clients[0].name }}</span>
    </div>

    <!-- Multiple clients => custom dropdown -->
    <v-menu
      data-testid="client-switcher__menu"
      v-else
      v-model="menu"
      offset-y
      :nudge-bottom="4"
      transition="fade-transition"
      :close-on-content-click="true"
      content-class="client-selector-menu"
    >
      <template #activator="{ on, attrs }">
        <div
          data-testid="client-switcher__activator"
          class="client-selector-activator d-flex align-center justify-start radius-small cursor-pointer gap-1"
          v-bind="attrs"
          v-on="on"
          :aria-label="`Select Client. Current: ${activeClientName}`"
          role="button"
          tabindex="0"
          @keyup.enter.stop="toggleMenu"
          @keyup.space.prevent.stop="toggleMenu"
        >
          <img data-testid="client-switcher__icon" class="nav-img-icon" src="/img/navicon/InvestIcon.svg" alt="">
          <p data-testid="client-switcher__current-name" class="text-truncate flex-grow-1 side-nav-text-color">{{ activeClientName }}</p>
          <v-icon data-testid="client-switcher__dropdown-icon" class="ml-2 rotate-transition" :class="{ 'rotated': menu }" color="white" width="20">{{ appendIcon }}</v-icon>
        </div>
      </template>
      <v-list data-testid="client-switcher__list" class="pa-2 client-selector-list d-flex flex-column gap-1">
        <v-list-item
          data-testid="client-switcher__option"
          v-for="c in clients"
          :key="c._id"
          class="client-option"
          :class="c._id === value ? 'active-option' : ''"
          @click="select(c)"
        >
          <v-list-item-title data-testid="client-switcher__option-title" class="text-truncate">{{ c.name }}</v-list-item-title>
          <v-icon data-testid="client-switcher__selected-icon" v-if="c._id === value" color="">mdi-check</v-icon>
        </v-list-item>
        <v-list-item data-testid="client-switcher__empty-state" v-if="!clients.length" disabled>
          <v-list-item-title data-testid="client-switcher__empty-text" class="white--text text--darken-1">No clients</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
  <div data-testid="client-switcher__no-clients" v-else class="client-selector-empty white--text text--darken-1 caption">No clients</div>
</template>

<script>
export default {
  name: 'ClientSwitcher',
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: String, default: '' },
    clients: { type: Array, default: () => [] },
    prependIcon: { type: String, default: 'mdi-domain' },
    appendIcon: { type: String, default: 'mdi-chevron-down' }
  },
  data() {
    return { menu: false };
  },
  computed: {
    activeClientName() {
      if (!this.clients?.length) return 'No Clients';
      const found = this.clients.find(c => c._id === this.value);
      return found?.name || this.clients[0]?.name || 'No Clients';
    },
    hasMultipleClients() {
      return this.clients?.length > 1;
    }
  },
  watch: {
    clients: {
      immediate: true,
      handler(list) {
        if (list?.length && !list.find(c => c._id === this.value)) {
          const firstId = list[0]._id;
          this.$emit('input', firstId);
          this.$emit('change', firstId);
        }
      }
    }
  },
  methods: {
    select(client) {
      if (!client || client._id === this.value) {
        this.menu = false;
        return;
      }
      this.$emit('input', client._id);
      this.$emit('change', client._id);
      this.menu = false;
    },
    toggleMenu() {
      this.menu = !this.menu;
    }
  }
};
</script>

<style scoped>
/* Uses global shared selectors; only unique sizing retained */
.client-selector-wrapper { min-width:200px; }
.client-selector-list { max-height:260px; overflow-y:auto; }
.client-single-chip { min-width:200px; }
</style>
